import { useCallback, useMemo } from "react";
import { NavigateFunction } from "react-router-dom";
import { EventPartial } from "../../../../types/events";
import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import StatusBadges from "../../StatusBadges";
import DropdownOptionsEvent from "../components/DropdownOptionsEvent/DropdownOptionsEvent";

type Options = {
  navigate: NavigateFunction;
  onDelete: (id: number) => void;
};

export default function useTableEvents({ navigate, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<EventPartial> = [
      {
        title: "TITRE",
        dataIndex: "name",
        key: "1",
        align: "left",
        width: 300,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "AUTEUR",
        dataIndex: ["creator", "fullname"],
        key: "author",
        align: "center",
        width: 200,
        render(value, record) {
          return (
            <a
              href={`/events/${record.creator?.fullname}`}
              className="author-name"
            >
              {value}
            </a>
          );
        },
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DATE",
        dataIndex: "dateEvt",
        key: "3",
        align: "center",
        width: 100,
        render: (value) => dayjs(value).format("DD/MM/YYYY"),
        sorter: (a, b) => (dayjs(a.dateEvt).isBefore(b.dateEvt) ? -1 : 1),
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "LIEU",
        dataIndex: "localisation",
        key: "place",
        align: "center",
        width: 100,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "GRAVITÃ",
        dataIndex: "gravity",
        key: "gravity",
        align: "center",
        width: 100,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "STATUT",
        dataIndex: "statut",
        key: "status",
        align: "center",
        width: 100,
        render: (value) => <StatusBadges value={value} type="events" />,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        key: "options",
        dataIndex: "",
        align: "center",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsEvent
            itemId={item.id}
            goToDetails={(id) => navigate(`/events/${id}`)}
            onModify={(id) => navigate(`/events/${id}/edit`)}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [navigate, onDelete]);

  const onRowClick = useCallback(
    (record: EventPartial) => {
      return {
        onClick: () => navigate(`/events/${record.id}`),
      };
    },
    [navigate],
  );

  return { columns, onRowClick };
}
